import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'paymentMethodPurchase', method: 'GET', body: null, token: token })
}
